import type { UpdateActivityStatusPayload } from './typings'
import type { State } from '../../typings'

export const updateActivityStatusProducer = (
  state: State,
  payload?: UpdateActivityStatusPayload,
): State => {
  const activities = payload
    ? state.activities.map((activity) => {
        if (activity.id === payload.id) {
          const activityUpdated = { ...activity, status: payload.status }
          if (
            !!payload.completedDate &&
            typeof payload.completedDate === 'string'
          ) {
            return {
              ...activityUpdated,
              completedDate: payload.completedDate,
            }
          }
          return activityUpdated
        }
        return activity
      })
    : state.activities

  return {
    ...state,
    current: undefined,
    content: 'list',
    activities,
  }
}
